import { StyledList } from './styles.js';
import React from '../../../../_snowpack/pkg/react.js';
export const FeatureSet = ({
  features
}) => {
  return /*#__PURE__*/React.createElement("ul", {
    style: {
      marginLeft: '-1em'
    }
  }, features.map((feature, key) => /*#__PURE__*/React.createElement(StyledList, {
    key: key,
    bold: feature.bold
  }, /*#__PURE__*/React.createElement("p", null, feature.text))));
};